import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';
import InputPlaceholder from '../InputPlaceholder/InputPlaceholder';
import { emptyFunction } from '../../core/util/function';
import { safeGet } from '../../core/util/object';

type OwnProps = {
  id?: string;
  autoFocus?: boolean;
  placeholderContainerName?: string;
  disabled?: boolean;
  funPlaceholder?: boolean;
  enableMask?: boolean;
  onBlur?: (...args: any[]) => any;
  placeholder?: string;
  onChange?: (...args: any[]) => any;
  value?: any;
  field?: any;
  sensitive?: boolean;
  validateField?: (...args: any[]) => any;
  inputProps?: any;
};

type State = any;

type Props = OwnProps & typeof MobilePhoneInput.defaultProps;

export default class MobilePhoneInput extends Component<Props, State> {
  static defaultProps = {
    enableMask: false,
    sensitive: false,
    validateField: emptyFunction,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      phone: this.props.field.value || safeGet(this.props.field)('initialValue.phone'),
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (nextProps.hasOwnProperty('value')) {
      const phone = nextProps.value;
      this.setState(phone);
    }
  }

  handleValue = (e: any) => {
    const phone = e.target.value.replace(/[^0-9]/g, '');
    const changedValue = { phone };
    this.setState(changedValue);
    return changedValue;
  };

  removeNonNumericCharacters = (e: any) => {
    const changedValue = this.handleValue(e);
    if (this.props.onChange) {
      this.props.onChange({ ...this.state, ...changedValue });
    }
  };

  handleOnBlur = (e: any) => {
    const changedValue = this.handleValue(e);
    if (this.props.onBlur) {
      this.props.onBlur({ ...this.state, ...changedValue });
    }

    this.props.validateField && this.props.validateField();
  };

  renderMaskedInput = () => (
    <MaskedInput
      autoFocus={this.props.autoFocus}
      className={this.props.sensitive ? 'inspectletIgnore' : ''}
      disabled={this.props.disabled}
      guide
      id={this.props.id}
      mask={['(', /[2-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      onBlur={this.handleOnBlur}
      onChange={this.removeNonNumericCharacters}
      onFocus={this.props.field.onFocus}
      placeholder={this.props.funPlaceholder ? '' : this.props.placeholder}
      placeholderChar={'\u00A0'}
      type="tel"
      value={this.state.phone}
    />
  );

  renderUnMaskedInput = () => (
    <input
      autoFocus={this.props.autoFocus}
      disabled={this.props.disabled}
      id={this.props.id}
      onBlur={this.handleOnBlur}
      onChange={this.removeNonNumericCharacters}
      placeholder={this.props.funPlaceholder ? '' : this.props.placeholder}
      type="tel"
      value={this.state.phone}
    />
  );

  render() {
    return (
      <div data-testid="masked-mobile-phone-input">
        {this.props.funPlaceholder && (
          <InputPlaceholder
            containerName={this.props.placeholderContainerName}
            field={this.props.field}
            // @ts-expect-error ts-migrate(2769) FIXME: Property 'focusId' does not exist on type 'Intrins... Remove this comment to see the full error message
            focusId={this.props.id}
            placeholder={this.props.placeholder}
          />
        )}
        {this.props.enableMask ? this.renderMaskedInput() : this.renderUnMaskedInput()}
      </div>
    );
  }
}
